module.exports = __webpack_public_path__ + "static/media/detectDataImage4.39462c18.png";